import { fabric } from "fabric";
import { IObjectOptions } from "fabric/fabric-impl";
import { AnnotationObjectDefaultProperties, ShapeGetData, ShapeOptions } from "./annotation-type";

export class Circle extends fabric.Circle implements ShapeGetData {
	constructor(private options: ShapeOptions, objectOptions?: IObjectOptions) {
		super({
			...objectOptions,
			...AnnotationObjectDefaultProperties,
			left: options.x,
			top: options.y,
			stroke: options.color,
			radius: Circle.getRadius(options.width, options.height),
			scaleX: Circle.getScaleX(options.width, options.height),
			scaleY: Circle.getScaleY(options.width, options.height),
			angle: options.rotate,
			fill: options.fill,
			opacity: options.opacity,
			originX: "center",
			originY: "center",
		});
	}

	private static getScaleX(width: number, height: number): number {
		const scaleX = Math.abs(width - height) / height + 1;
		const isScaleApplied = width > height;
		const defaultScaleX = 1;
		return isScaleApplied ? scaleX : defaultScaleX;
	}
	private static getScaleY(width: number, height: number): number {
		const scaleY = Math.abs(width - height) / width + 1;
		const isScaleYApplied = height > width;
		const defaultScaleY = 1;
		return isScaleYApplied ? scaleY : defaultScaleY;
	}
	private static getRadius(width: number, height: number): number {
		return Math.min(width, height) / 2;
	}

	public setData(update: Partial<ShapeOptions>): void {
		Object.assign(this.options, update);

		this.setOptions({
			left: this.options.x,
			top: this.options.y,
			stroke: this.options.color,
			radius: Circle.getRadius(this.options.width, this.options.height),
			scaleX: Circle.getScaleX(this.options.width, this.options.height),
			scaleY: Circle.getScaleY(this.options.width, this.options.height),
			angle: this.options.rotate
		});
	}

	public getData(): ShapeOptions {
		const w = this.width!;
		const h = this.height!;
		const scaleX = this.scaleX!;
		const scaleY = this.scaleY!;

		return {
			type: this.options.type,
			width: w * scaleX,
			height: h * scaleY,
			x: this.left!,
			y: this.top!,
			color: this.stroke!,
			rotate: this.angle || 0,
			fill: this.fill,
			opacity: this.opacity!
		};
	}
}
